export const listJournalEntries = /* GraphQL */ `
  query ListJournalEntries($userId: ID!) {
    listJournalEntries(userId: $userId) {
      userId
      entryId
      recipeId
      recipeName
      servingSize
      cannabinoidMg
      cannabinoidType
      consumedAt
      onsetMinutes
      peakMinutes
      durationMinutes
      effects
      notes
      rating
      createdAt
    }
  }
`;

export const createJournalEntry = /* GraphQL */ `
  mutation CreateJournalEntry($input: CreateJournalEntryInput!) {
    createJournalEntry(input: $input) {
      userId
      entryId
      recipeId
      recipeName
      servingSize
      cannabinoidMg
      cannabinoidType
      consumedAt
      onsetMinutes
      peakMinutes
      durationMinutes
      effects
      notes
      rating
      createdAt
    }
  }
`;
